export const predefinedList = [
  {
    name: 'Last 7 Days',
    value: '7',
  },
  {
    name: 'Last 14 Days',
    value: '14',
  },
  {
    name: 'Last 1 Month',
    value: '30',
  },
  {
    name: 'Last 3 Months',
    value: '90',
  },
  {
    name: 'Last 6 Months',
    value: '180',
  },
  {
    name: 'Last 1 Year',
    value: '365',
  },
  {
    name: 'Last 3 Years',
    value: '1095',
  },
  {
    name: 'Custom Range',
    value: 'custom',
  },
];
